"use strict";

define('service/settings.service',['require','exports','module','appkit/service'],function (require, exports, module) {
  var Service = require('appkit/service');
  var SettingsService = Service.extend({
    replies: {
      'get:config': 'getConfig',
      'get:all:settings': 'getAllSettings',
      'get:setting:model': 'getSettingModel',
      'get:setting': 'getSetting',
      'get:all:user:settings': 'getAllUserSettings',
      'get:user:setting:model': 'getUserSettingModel',
      'get:user:setting': 'getUserSetting'
    },
    getConfig: function getConfig() {
      return this.app.config;
    },
    getAllSettings: function getAllSettings() {
      return this.app.settings;
    },
    getSettingModel: function getSettingModel(settingKey) {
      return this.app.settings.get(settingKey);
    },
    getSetting: function getSetting(settingKey) {
      var settingModel = this.getSettingModel(settingKey);
      return settingModel ? settingModel.get('value') : null;
    },
    getAllUserSettings: function getAllUserSettings() {
      return this.app.userSettings;
    },
    getUserSettingModel: function getUserSettingModel(userSettingKey) {
      return this.app.userSettings.findWhere({
        name: userSettingKey
      });
    },
    getUserSetting: function getUserSetting(userSettingKey) {
      var userSettingModel = this.getUserSettingModel(userSettingKey);
      return userSettingModel ? userSettingModel.get('value') : null;
    }
  });
  module.exports = SettingsService;
});

